import React, { useEffect, useState } from 'react';
import { getFirestore, doc, getDoc, onSnapshot } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import appFirebase from '../Firebase/Firebase';
import './coindashboard.css';
import { FaBell, FaEyeSlash } from 'react-icons/fa';
import ServicioImg from '../img/servicioN.png';
import EducacionImg from '../img/academiaN.png';
import CoworkingImg from '../img/coworkingN.png';
import EventoImg from '../img/eventoN.png';
import Avatar from '../images/1.png';
import Logo from '../img/logoDark.png'
import { Link } from 'react-router-dom';

const db = getFirestore(appFirebase);
const auth = getAuth(appFirebase);
const CoinsDashboard = () => {
  const [coins, setCoins] = useState(0);
  const [coinsComprados, setCoinsComprados] = useState(0);
  const [purchaseDate, setPurchaseDate] = useState(new Date());
  const [expirationDate, setExpirationDate] = useState(new Date());
  const [tiempoRestante, setTiempoRestante] = useState('');
  const [userName, setUserName] = useState('');

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (currentUser) => {
      if (currentUser) {
        const docRef = doc(db, 'usuarios', currentUser.uid);
        const unsubscribeSnapshot = onSnapshot(docRef, (docSnap) => {
          if (docSnap.exists()) {
            const data = docSnap.data();
            setCoins(data.coins || 0);
            setCoinsComprados(data.coinsComprados || 0);
            setUserName(data.name || currentUser.email);
            if (data.coinRenovation && data.coinExpiration) {
              const purchase = new Date(data.coinRenovation.seconds * 1000);
              const expiration = new Date(data.coinExpiration.seconds * 1000);
              setPurchaseDate(purchase);
              setExpirationDate(expiration);
            }
          }
        });
        return () => unsubscribeSnapshot();
      }
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const now = new Date();
    const diff = expirationDate - now;
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    setTiempoRestante(`${days}d, ${hours}h, ${minutes}m`);
  }, [purchaseDate, expirationDate]);

  return (
  <div className="coinsdash-container">
    {/* SECCIÓN IZQUIERDA (GRID) */}
    

    {/* SECCIÓN DERECHA (MAIN) */}
    <div className="coinsdash-main-content">
      <h4 className="coinsdash-top">EN TODAS PARTES</h4>
      <div className="coinsdash-logo">
        <img src={Logo} alt="logo-Dashboard-Coins" />
      </div>

      <div className="coinsdash-user">
        <div className="user-info">
          <img src={Avatar} alt="avatar" className="avatar" />
          <div>
            <p className="welcome-text">Bienvenido {userName}</p>
            <p className="work-text">Hoy trabajas en...</p>
          </div>
        </div>
        <div className="notif-icon">
          <FaBell />
          <span className="notif-dot">1</span>
        </div>
      </div>

      <div className="coinsdash-balance-card">
        <p className="balance-label">Disfruta de tus COINS</p>
        <div className="balance-value">
          <p className="amount">$ {coins}  <FaEyeSlash /></p>
        </div>
      </div>

      <div className="coinsdash-banner">
        TODO EN UN SOLO <br /> LUGAR
      </div>

      <div className="coinsdash-footer">
        LAOFI.WORK
      </div>
    </div>
    <div className="coinsdash-grid">
      <Link to="/coworking">
        <div className="grid-item">
          <img src={CoworkingImg} alt="coworking" />
        </div>
      </Link>
      <Link to="/servicios">
        <div className="grid-item">
          <img src={ServicioImg} alt="servicios" />
        </div>
      </Link>
      <Link to="https://edu-laofi-academy.odoo.com/" target="_blank">
        <div className="grid-item">
          <img src={EducacionImg} alt="educación" />
        </div>
      </Link>
      <Link to="https://laofieventos.odoo.com/" target="_blank">
        <div className="grid-item">
          <img src={EventoImg} alt="eventos" />
        </div>
      </Link>
    </div>
  </div>
);

};
export default CoinsDashboard;
